import request from '@/http/request'

export const getAbnormalList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/abnormal-package/query`, params)
}
export const getAbnormalLogList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/abnormal-package/log/query`, params)
}
export const getAbnormalExport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/abnormal-package/export`, params)
}
